module.exports = __webpack_public_path__ + "34b2f08b3f423d33f2bf59907c128b63.png";